export default "__VITE_ASSET__CRvVL7g___"